import React, { useCallback, useEffect, useState } from 'react';
import DomainName from './DomainName';
import VerifyDomain from './VerifyDomain';
import { DomainDetails, getDomainDetails } from 'common/modules/customDomains';

interface Props {
	domain: string | undefined;
	onClose: () => void;
	shopId: string;
}

const ConnectDomainModal = (props: Props) => {
	const { onClose, domain, shopId } = props;
	const [domainName, setDomainName] = useState<string>(domain ?? '');
	const [domainDetails, setDomainDetails] = useState<DomainDetails | undefined>(undefined);
	const [view, setView] = useState<'add-domain' | 'verify-domain'>(
		domain ? 'verify-domain' : 'add-domain',
	);

	const updateDomainDetails = useCallback(async (domainName: string) => {
		const domainDetails = await getDomainDetails(domainName);
		setDomainDetails(domainDetails);
	}, []);

	useEffect(() => {
		if (!!domain) {
			updateDomainDetails(domain);
		}
	}, [domain, updateDomainDetails]);

	const handleDomainNameConfirm = async (domainName: string) => {
		updateDomainDetails(domainName);
		setDomainName(domainName);
		setView('verify-domain');
	};

	return view === 'add-domain' ? (
		<DomainName
			currentDomainName={domainName}
			onCancel={onClose}
			onConfirm={handleDomainNameConfirm}
		/>
	) : view === 'verify-domain' && !!domainDetails ? (
		<VerifyDomain
			domainDetails={domainDetails}
			onBackClick={() => setView('add-domain')}
			onClose={onClose}
			isExistingDomain={!!domain}
			shopId={shopId}
		/>
	) : null;
};

export default ConnectDomainModal;
